import Config           from '../../common/model/Config';
import logo_pass        from '../../common/resource/img/logo_pass.png';
import logo_payco       from '../../common/resource/img/logo_payco.png';
import logo_kakao       from '../../common/resource/img/logo_kakao.png';
import logo_kakaopay    from '../../common/resource/img/logo_kakaopay.png';
import logo_kb          from '../../common/resource/img/logo_kb.png';
import logo_samsung     from '../../common/resource/img/logo_samsung.png';
import logo_naver       from '../../common/resource/img/logo_naver.png';
import logo_toss        from '../../common/resource/img/logo_toss.png';
import logo_shinhan     from '../../common/resource/img/logo_shinhan.png';
import logo_banksalad   from '../../common/resource/img/logo_banksalad.png';
import logo_hana        from '../../common/resource/img/logo_hana.png';
import logo_sample      from '../../common/resource/img/logo_sample.png';
import { providerChk }  from '../../common/utils/provider.id.check';
import { device }       from '../../common/utils/deviceCheck';
import { viewEvent }    from '../controller/viewEventCtrl';

Array.prototype.shuffle_random = function () {
    var length = this.length;
    while (length) {
        var index = Math.floor((length--) * Math.random());
        var temp = this[length];
        this[length] = this[index];
        this[index] = temp;
    }
    return this;
};
Array.prototype.shuffle_order = function () {
    const dbProviders = this;
    const orderList = Config.provider.order.list;
    orderList.forEach((configProvider,i)=>{
        if(configProvider.order === undefined){
            viewEvent.view_msg("안내","",`Percent 설정값이 부족합니다.(list.order)`);
            return;
        }
    });
    //값 생성
    orderList.forEach((configProvider,i)=>{
        dbProviders.forEach((dbProvider)=>{
            if(configProvider.providerId == dbProvider.providerId){
                dbProvider["order"] = configProvider.order;
            }
        })
    })
    //정렬 및 순서셋팅이없는 인증기관은 DB순서대로
    dbProviders.sort(function(a,b) { 
        return a.order < b.order || b.order === undefined ? -1 : a.order < b.order ? 1 : 0;
    });

    return dbProviders;
};
Array.prototype.shuffle_percent = function () {
    var totalChance=0, pOrder = 0;
    const dbProviders = this;
    var isBreak = false;

    function isValidation(){
        if(totalChance > 100){
            viewEvent.view_msg("안내","",`Percent 설정값이 초과하였습니다.(${totalChance-100})`);
            isBreak = true;
        }else if(totalChance < 100){
            viewEvent.view_msg("안내","",`Percent 설정값이 부족합니다.(${100-totalChance})`);
            isBreak = true;
        }
    }
    
    //설정값 셋팅
    const orderList = Config.provider.order.list;
    orderList.sort(function(a,b) { 
        return a.percent > b.percent ? -1 : a.percent < b.percent ? 1 : 0;
    });
    orderList.forEach((configProvider,i)=>{
        totalChance += Number(configProvider.percent);
        if(i == 0){
            configProvider["sNum"]=0
            configProvider["eNum"]=Number(configProvider.percent)
        }else if(i == orderList.length-1){
            configProvider["sNum"]=Number(orderList[i-1].eNum)
            configProvider["eNum"]=100
        }else{
            configProvider["sNum"]=Number(orderList[i-1].eNum)
            configProvider["eNum"]=Number(orderList[i-1].eNum)+Number(configProvider.percent)
        }
    })
    while(pOrder < orderList.length){
        isValidation();
        if(isBreak){
            break;
        }
        const rand = Math.floor(Math.random() * 100);
        orderList.forEach((configProvider,i)=>{
            if(configProvider.providerId === undefined){
                viewEvent.view_msg("안내","",`Percent 설정값이 부족합니다.(list.providerId)`);
                isBreak = true;
                return;
            }
            if(configProvider.percent === undefined){
                viewEvent.view_msg("안내","",`Percent 설정값이 부족합니다.(list.percent)`);
                isBreak = true;
                return;
            }
            if(rand >= configProvider.sNum && rand < configProvider.eNum && configProvider.pOrder === undefined ){
                configProvider["pOrder"]= ++pOrder;
                configProvider["rand"]=rand;
            }
        });
    }
    //값 생성
    orderList.forEach((configProvider,i)=>{
        dbProviders.forEach((dbProvider)=>{
            if(configProvider.providerId == dbProvider.providerId){
                dbProvider["order"] = configProvider.pOrder;
            }
        })
    })
    //정렬 및 순서셋팅이없는 인증기관은 DB순서대로
    dbProviders.sort(function(a,b) { 
        return a.order < b.order || b.order === undefined ? -1 : a.order < b.order ? 1 : 0;
    });
    return dbProviders;
};

export const process = {
    providerService: (res) => {
        var resultArr = [];
        var providerArr = [];
        const mode = Config.provider.mode.id; //dev, prod
        const typeId = Config.provider.type.id; //gov, ent

        //공공,민간,개발,운영 중 해당하는 List로 정련
        res.forEach((d,i)=>{
            if(device.checkMobileType() == "IOS" && providerChk.isSamsung(d.provider_id)){
                return;
            }
            if(d.provider_type != typeId || d.oper_sort != mode){ 
                return;
            }
            providerArr.push(d);
        });

        //Use Provider
        providerArr.forEach((d,i)=>{
            //Config.auth.json의 unUseIdList 옵션 체크
            if(!unUseProviderCheck(d.provider_id)){
                return;
            }
            //d.status_code N과 상관없이 다 표시 / unuseStyle에 따라 화면에서 숨김
            var provider = process.createData(d);
            resultArr.push(provider);
        });
        
        var res = "";
        const order = Config.provider.order
        if(order == undefined){
            return resultArr.shuffle_random(); 
        }        
        if(order.mode == undefined){
            viewEvent.view_msg("안내","","provider.order.mode key값이 존재하지 않습니다.");
            return res;
        }
        if(order.list == undefined){
            viewEvent.view_msg("안내","","provider.order.list key값이 존재하지 않습니다.");
            return res;
        }

        if(order.mode == "percent"){
            res = resultArr.shuffle_percent();
        }else if(order.mode == "order"){
            res = resultArr.shuffle_order();
        }else if(order.mode == "random"){
            res = resultArr.shuffle_random();
        }else{
            viewEvent.view_msg("안내","","mode(random, order, percent) 설정이 잘못되었습니다.");
        }
        return res;
    },
    createData: (d) => {
        const providerJson = {
            providerLabel: "",
            providerId: "",
            providerName: "",
            providerLogo: "",
            unuse_style: d.unuse_style,
            status_code: d.status_code.trim()
        }
        
        if(providerChk.isPass(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "통신사패스";
            providerJson.providerLabel='통신사패스<br><span>(SKT, KT, LGU+)</span>';
            providerJson.providerLogo = logo_pass;
        }else if(providerChk.isKakao(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "카카오톡"
            providerJson.providerLabel='카카오톡'
            providerJson.providerLogo = logo_kakao;
        }else if(providerChk.isKakaoPay(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "카카오페이"
            providerJson.providerLabel='카카오페이'
            providerJson.providerLogo = logo_kakaopay;
        }else if(providerChk.isPayco( d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "페이코"
            providerJson.providerLabel='페이코'
            providerJson.providerLogo = logo_payco;
        }else if(providerChk.isSamsung(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "삼성패스"
            providerJson.providerLabel='삼성패스'
            providerJson.providerLogo = logo_samsung;
        }else if(providerChk.isKb(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "KB모바일"
            providerJson.providerLabel='KB모바일<br>인증서'
            providerJson.providerLogo = logo_kb;
        }else if(providerChk.isToss(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "토스"
            providerJson.providerLabel='토스'
            providerJson.providerLogo = logo_toss;
        }else if(providerChk.isNaver(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "네이버"
            providerJson.providerLabel='네이버'
            providerJson.providerLogo = logo_naver;
        }else if(providerChk.isShinhan(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "신한"
            providerJson.providerLabel='신한인증서'
            providerJson.providerLogo = logo_shinhan;
        }else if(providerChk.isBanksalad(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "뱅크샐러드"
            providerJson.providerLabel='뱅크샐러드'
            providerJson.providerLogo = logo_banksalad;
        }else if(providerChk.isHana(d.provider_id)){
            providerJson.providerId = d.provider_id;
            providerJson.providerName = "하나"
            providerJson.providerLabel='하나인증서'
            providerJson.providerLogo = logo_hana;
        }else{
            providerJson.providerId = d.provider_id;
            providerJson.providerName = d.name;
            providerJson.providerLabel= d.name;
            providerJson.providerLogo = logo_sample;
        }
        return providerJson;
    }
}


/**
 * Config의 Provider Un Use 항목 체크
 * 제외 항목이 있을 시 false를 반환
 */
function unUseProviderCheck(providerId){
    const unUseProviderIdList = Config.provider.unUseIdList;
    if(unUseProviderIdList.length == 0){
        return true;
    }
    if(unUseProviderIdList.indexOf(providerId) != -1 ){
        return false;
    }
    return true;
}